import React from 'react';
import PropTypes from 'prop-types';

/**
 * CardHeaderTitle - A wrapper that renders a standard HTML p element with Bulma card-header-title class names
 * 
 * This component accepts the same props as Bloomer CardHeaderTitle for easy migration
 */
const CardHeaderTitle = ({
  className,
  style,
  children,
  ...props
}) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = ['card-header-title'];
    
    // Add custom class names
    if (className) {
      classes.push(className);
    }
    
    return classes.join(' ');
  };

  return (
    <p 
      className={getClassNames()} 
      style={style}
      {...props}
    >
      {children}
    </p>
  );
};

CardHeaderTitle.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node
};

CardHeaderTitle.defaultProps = {
  className: '',
  style: {},
  children: null
};

export default CardHeaderTitle;
